<template>
  <div class="footer">
    <div v-for="(item, index) in list" :key="index" class="item">
      <div>
        <span class="bigNum">{{ item.num }}</span>
        <span class="unit unit1">{{ item.itemFirst }}</span>
        <span class="unit unit2" v-if="item.itemSecond">{{ item.itemSecond }}</span>
      </div>
      <div>
        {{ item.title }}
      </div>
    </div>
  </div>
</template>

<script>
import { getIndexBottomData } from '@/api/viewIndex';

export default {
  name: 'Footer',
  data() {
    return {
      list: [],
    };
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      getIndexBottomData()
          .then((res) => {
            console.log(res);
            this.list = res.data.result || [];
          })
          .catch(err => {
            console.log(err);
          });
    },
  },
};
</script>

<style lang="scss" scoped>
.footer {
  width: 100%;
  height: 120px;
  display: flex;
  justify-content: space-around;
  align-items: center;
  background: url("../../assets/images/footerBg.png") no-repeat;
  background-size: 100% 100%;

  .item {
    width: 25%;
    text-align: center;
    color: #ffffff;
    position: relative;
    &:not(:last-child)::after {
      content: '';
      display: inline-block;
      width: 1px;
      height: 80px;
      background: #ffffff;
      position: absolute;
      right: 0;
      top: 0;
    }
    .bigNum {
      font-size: 40px;

    }
    .unit {
      font-weight: bold;
    }
    .unit1 {
      margin: 0 5px;
    }
  }
}
</style>
